<template>
    <div class="null_car" id="empty_car">
        <p>
            <img src="../../assets/picture/car_null.png" class="nucar" width="100" height="100">
        </p>
        <p class="f14 c9 mt15">购物车里好寂寞，快去选购吧</p>
        <p class="lh16">&nbsp;</p>
        <div class="pd10">
            <a href="javascript:;" class="car_btn">去挑选商品</a>
        </div>
        <p class="f0 alC">
            <a href="javascript:;" class="w_ct"><b class="red">#</b>延时喷剂</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>飞机杯</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>仿真阳具</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>润滑液</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>女优名器</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>锁精环</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>情欲提升</a>
            <a href="javascript:;" class="w_ct"><b class="red">#</b>G点棒</a>
        </p>
    </div>
</template>

<script>

export default {
    components:{
        
    }
}
</script>

<style scoped>
@import url('../../assets/css/car.css');
</style>


// WEBPACK FOOTER //
// src/components/car/nothing_car.vue